import React, { useCallback, useEffect, useRef, useState } from "react";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
import logo from "asset/img/logo/vivn.png";

const QRCodeLogo = ({ base64 }) => {
  // -------------------------- VAR -----------------------------
  const canvasRef = useRef(null);

  // -------------------------- STATE ---------------------------
  const [combine, setCombine] = useState("");
  const [baseLogo, setBaselogo] = useState("");

  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleCanvas = useCallback(async (base64, baselogo) => {
    try {
      // Tạo canvas ẩn
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const SIZE = 280;

      // Tải QR code
      const qrImage = new Image();
      qrImage.src = base64;
      await new Promise((resolve) => (qrImage.onload = resolve));

      // Thiết lập kích thước canvas
      canvas.width = SIZE;
      canvas.height = SIZE;

      // Vẽ QR code lên canvas
      ctx.drawImage(qrImage, 0, 0, SIZE - 2, SIZE - 2);

      const logoImage = new Image();
      logoImage.src = baselogo;
      await new Promise((resolve) => (logoImage.onload = resolve));

      //   // Tính toán kích thước logo (20% kích thước QR)
      const logoSize = Math.min(SIZE, SIZE) * 0.15;
      const x = (SIZE - logoSize) / 2;
      const y = (SIZE - logoSize) / 2;

      //   // Vẽ logo lên QR code
      ctx.drawImage(logoImage, x, y, logoSize, logoSize);

      // Chuyển thành base64
      setCombine(canvas.toDataURL("image/png"));
    } catch (error) {
      console.error("Error combining images:", error);
    }
  }, []);

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  useEffect(() => {
    if (base64 && baseLogo) {
      handleCanvas(base64, baseLogo);
    }
  }, [base64, baseLogo, handleCanvas]);

  useEffect(() => {
    const convertBase64FromFile = async () => {
      // 1. Fetch dữ liệu từ đường dẫn asset
      const response = await fetch(logo);

      // 2. Chuyển response thành Blob
      const url = response.url;

      setBaselogo(url);
    };

    convertBase64FromFile();
  }, []);
  // -------------------------- MAIN ----------------------------

  if (!base64) return null;
  return (
    <div>
      {combine && base64 ? (
        <img src={combine} alt="QR with Logo" ref={canvasRef} />
      ) : (
        <div>Đang tạo QR code...</div>
      )}
    </div>
  );
};
export default QRCodeLogo;
